import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import StatusRecordBarChart from '../cards/StatusRecordBarChart'
import StatusRecordTable from '../cards/StatusRecordTable.vue'
import './statusrecord.less'
import { exportStatusRecord } from '@/api/api';

@Component({
  components: {
    StatusRecordBarChart,
    StatusRecordTable
  }
})
export default class StatusRecordBody extends Vue {
  @Prop({ default: () => ([]) }) tabsdData: Array<any>
  @Prop({ default: () => ([]) }) data: Array<any>
  @Prop({ default: () => ([]) }) columns: Array<any>
  @Prop({ default: () => ({}) }) searchParams: Object
  @Prop({ default: '' }) dateTime: String
  @Prop({ default: false }) loading: Boolean
  showType: String = 'gantt'
  visible: Boolean = false
  checkItem = []
  color = ['#37A2DA', '#32C5E9', '#67E0E3', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF']
  defaultActiveKey = 0
  showOutPut = false

  handleShowTypeChange(value) {
    this.showType = value
    this.defaultActiveKey = 0
    this.$emit('changeTabs', value) // 切换图表
    /*this.checkItem = []
    this.data.forEach(res => {
      res.checked = false
    })*/
  }

  dataHsItem() {
    let bool = false
    this.data.forEach(res => {
      if (res.recordItems.length > 0) {
        bool = true
      }
    })
    return bool
  }

  changeDateTabs(value) { // 切换日期tab
    this.defaultActiveKey = value
    this.$emit('changeDateTabs', value)
  }

  callback(val) {
  }

  renderLoading() {
    return (
      <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
        <a-spin>
          <a-icon slot="indicator" type="loading" style="font-size: 34px" spin/>
        </a-spin>
      </div>
    )
  }

  // 点击导出
  handler() {
    this.$emit('getWork')
    if (this.data.length) {
      this.showOutPut = true
    } else {
      this.$message.error(this.$t('page_no_data_export_or_no_query'))
    }
  }

  chartBody() {
    if (this.showType === 'gantt') {
      return (this.dataHsItem() ?
          <status-record-bar-chart dateTime={this.dateTime} columns={this.columns}
                                   dataValue={this.data} color={this.color}/>
          :
          <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
            <wm-empty text={this.$t('page_wm_empty')}/>
          </div>
      )
    } else {
      return (<status-record-table dataValue={this.data}/>)
    }
  }

  async handleMenuClick(val) {
    let startSec = null, endSec = null
    let searchParams: any = this.searchParams
    if (searchParams.start) {
      startSec = (new Date(searchParams.start).getTime() - new Date(new Date().toLocaleDateString()).getTime()) / 1000
    }
    if (searchParams.end) {
      endSec = (new Date(searchParams.end).getTime() - new Date(new Date().toLocaleDateString()).getTime()) / 1000
    }
    const data = {
      date: searchParams.date,
      duration: searchParams.duration,
      start: startSec,
      end: endSec,
      iotStatus: searchParams.iotStatus.length ? searchParams.iotStatus : [1, 4],
      workStationList: searchParams.workStationList
    }
    let params = {}
    if (val.key === '1') {
      params = {
        date: searchParams.date,
        iotStatus: [1, 4],
        workStationList: searchParams.workStationList
      }
    } else {
      params = data
    }

    let res = await exportStatusRecord(params)
    // 创建隐藏的可下载链接
    var a = document.createElement('a')
    a.download = `${this.$t('page_status_record')}.xlsx`
    a.style.display = 'none'
    // 字符内容转变成blob地址
    // var blob = new Blob([res])
    let url = URL.createObjectURL(res)
    a.href = url
    // 触发点击
    document.body.appendChild(a)
    a.click()
    // 然后移除
    URL.revokeObjectURL(url)
    document.body.removeChild(a)

  }

  render() {
    return (
      <blank-view>
        <div slot="action" style="display: flex; justify-content: space-between;">
          <div>
            {/*导出*/}
            <a-dropdown>
              <a-menu slot="overlay" onClick={this.handleMenuClick}>
                <a-menu-item key="1">{ this.$t('page_product_export') }</a-menu-item>
                <a-menu-item key="2">{ this.$t('page_product_confirm_search_export') }</a-menu-item>
              </a-menu>
              <a-button style="margin-left: 8px">
                {this.$t('page_product_export')}
                <a-icon type="down"/>
              </a-button>
            </a-dropdown>

            {/*<a-button type="primary" onClick={() => this.handler()}>{this.$t('page_product_export')}</a-button>*/}

          </div>
          <div style="display: flex; justify-content: flex-end;">
            <a-radio-group value={this.showType} onChange={data => this.handleShowTypeChange(data.target.value)}>
              <a-radio-button value="gantt">
                {this.$t('page_operation_statistics_gantt')}
              </a-radio-button>
              <a-radio-button value="table">
                {this.$t('page_operation_statistics_tablechart')}
              </a-radio-button>
            </a-radio-group>
          </div>
        </div>

        <div style="height:100%">
          <div style="width: 100%">
            {this.showType === 'gantt' &&
            <a-tabs
              active-key={this.defaultActiveKey}
              tab-position={'top'}
              onPrevClick={this.callback}
              onNnextClick={this.callback}
              onChange={value => this.changeDateTabs(value)}
            >
              {this.tabsdData.length > 0 ? this.tabsdData.map((res, index) => {
                return (<a-tab-pane key={index} tab={res.title}></a-tab-pane>)
              }) : null}
            </a-tabs>
            }
            {this.showType === 'gantt' &&
            <div style="padding: 8px;">
              {this.columns.map((res) => {
                return (<a-badge style="margin-left: 8px;" color={res.color} text={res.collectStatusName}/>)
              })}
            </div>}
          </div>
          <div class="statusRecord-content">
            {this.loading ? this.renderLoading() : this.dataHsItem() ? this.chartBody() : <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;"><wm-empty text={this.$t('page_wm_empty')} /></div>}
            {/*{this.loading ? this.renderLoading() : this.chartBody()}*/}
          </div>
        </div>
      </blank-view>
    )
  }
}
